import { render, staticRenderFns } from "./StudentContent.vue?vue&type=template&id=f4f637e4&"
import script from "./StudentContent.vue?vue&type=script&lang=js&"
export * from "./StudentContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports